import React, { useEffect, useState } from "react";
import { RefundClientAppConfig } from "../../common/types";

interface ConfigContextInterface {
  config: RefundClientAppConfig;
}

export const ConfigContext = React.createContext<ConfigContextInterface>({
  config: {
    inventoryUrl: "",
    magentoUrl: "",
  },
});

export const Config: React.FC = props => {
  const [config, setConfig] = useState<RefundClientAppConfig | undefined>(undefined);

  useEffect(() => {
    const fetchConfig = async () => {
      const fetchResponse = await fetch("/api/config");
      const data = (await fetchResponse.json()).body;
      setConfig(data);
    };
    fetchConfig();
  }, []);

  return config ? <ConfigContext.Provider value={{ config }}>{props.children}</ConfigContext.Provider> : null;
};
